import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { paths } from '../../../../common/constants/pathVariables.js';
import { AuthorizationSuccessfulScene } from '../../../../components/AuthorizationSuccessfulScene/AuthorizationSuccessfulScene.js';

export const AuthorizedNumberPortingPath = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  // We need to capture in ref so we can remove from location.state while continuing to render the right thing.
  const hasValidState = useRef(state?.success === true);

  useEffect(() => {
    if (hasValidState.current) {
      navigate('', { replace: true, state: null }); // Remove from location.state so refresh causes 404.
    } else {
      navigate(paths.NOT_FOUND_404, { replace: true, state: null }); // Direct navigation or refresh ==> 404-
    }
  }, [navigate]);

  return <AuthorizationSuccessfulScene />;
};
